import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id", "onClick"]

import { GamesAnalytics } from "@/games/analytics/analytics-games";
import { useGamesGrid } from "@/games/composables/use-games-grid";
import { GamesFilterSortType } from "@/games/models/games-filter-parameters";


export default /*@__PURE__*/_defineComponent({
  __name: 'games-sort-options',
  emits: ["sortApplied"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { reloadWithFilter, filterParameters, getFilterSortTypeLabel } = useGamesGrid();

const filterOptions = [GamesFilterSortType.Newest, GamesFilterSortType.Oldest, GamesFilterSortType.MostPlayed];

const selectFilter = async (type: GamesFilterSortType) => {
    filterParameters.value.sortType = type;
    await reloadWithFilter();
    emit("sortApplied");
    GamesAnalytics.pushSort(getFilterSortTypeLabel(type));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filterOptions, (sortType, index) => {
      return _createElementVNode("label", {
        class: "games-filter__option-dialog-label",
        key: index
      }, [
        _createElementVNode("input", {
          id: 'sort-option-' + index,
          type: "radio",
          onClick: ($event: any) => (selectFilter(sortType))
        }, null, 8, _hoisted_1),
        _createTextVNode(" " + _toDisplayString(_unref(getFilterSortTypeLabel)(sortType)), 1)
      ])
    }), 64))
  ]))
}
}

})